import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  setPopup,
  startPointEnum,
  changeHandler,
  setStartPoint,
  validateAccountToIMEIService,
  errorDescriptionEnum,
  confirmPhoneConnectedToIMEI,
  setCurrentStep,
  stepEnum,
  formName,
  saveToHistory,
  saveDWHParams,
  hideErrorMessage,
  getGeneralData,
  confirmPhoneNumber
} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextFieldWithRadio from '../../../Shared/TextFieldWithRadio/TextFieldWithRadio';
import DeniedMessageBox from '../../../Shared/DeniedMessageBox/DeniedMessageBox';
import {dwhValidateStepDisplay, dwhValidateStepButtonClick} from '../reports/dwhReports';
import {gtag4} from '../../../../utilities/analytics/tracking';
const ValidateComponent = (props) => {
  const selectedHetPay = props.portalState.selectedHetPay;
  const customerName = props.loginData.userDetails.firstName + ' ' + props.loginData.userDetails.lastName;
  const subscriber = props.loginData.userDetails.contactNumber;
  console.info(props);
  useEffect(() => {
    gtag4({
      event: 'DeviceRepair_FormImp',
      action: 'FormImp',
    });
    props.saveToHistory();
    props.saveDWHParams({selectedHetPay, customerName, subscriber});
    dwhValidateStepDisplay({selectedHetPay, customerName, subscriber});
  }, []);

  useEffect(() => {
    if (
      props.deviceRepairData.showErrorMessage &&
      (props.deviceRepairData.errorType == errorDescriptionEnum.NO_EQUIPMENT_IS_ATTACHED ||
        props.deviceRepairData.errorType == errorDescriptionEnum.WARR_ISSUR_IND)
    ) {
      gtag4({
        event: 'DeviceRepair_ImeiErrorPage',
        action: 'ImeiErrorPage',
        error: `המכשיר לא כלול באחריות מקיפה/שירות תיקונים. יש לפנות לאחראי/ת השירות להמשך טיפול`,
      });
    }
  }, [props.deviceRepairData.errorDescription]);

  const fields = {
    phone: {
      label: 'מספר טלפון',
      phone: props.deviceRepairData.form.phone,
      preText: 'מספר טלפון',
      errors: props.deviceRepairData.form.errors,
      placeholder: 'מספר טלפון',
    },
    imei: {
      label: 'IMEI',
      imei: props.deviceRepairData.form.imei,
      preText: 'IMEI',
      errors: props.deviceRepairData.form.errors,
      placeholder: 'IMEI',
    },
  };

  function handleInputChange({field, value}) {
    if (props.deviceRepairData.showErrorMessage) {
      props.hideErrorMessage();
    }

    props.changeHandler({
      name: field,
      value: value,
      rule: props.deviceRepairData.form?.rules[field],
      form: formName.form,
    });
  }

  function saveToHistoryAndContinue() {
    props.saveToHistory();

    if (props.deviceRepairData.showConfirmPhoneMsg) {
      handleCurrentStep();
    } else {
      gtag4({
        event: 'DeviceRepair_ContinueButton',
        action: 'ContinueButton',
        button: 'המשך',
      });
      validateAndSend();
    }
  }

  function validateAndSend() {
    if (props.deviceRepairData.startPoint === startPointEnum.IMEI &&
      props.deviceRepairData.confirmedPhoneNumber &&
      props.deviceRepairData.selectedIMEI === props.deviceRepairData.form.imei?.trim()) {
      props.setCurrentStep(stepEnum.CAUSE_SELECTION);
    }
    let sendingData = {
      orgId: props.portalState.selectedHetPayId,
      isPrivate: props.deviceRepairData?.isPrivate,
      isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value === true
    };
    let dwhParam;

    if (props.deviceRepairData.startPoint === startPointEnum.PHONE) {
      if (!props.deviceRepairData.form.phone?.trim()) {
        handleInputChange({field: 'phone', value: ''});
      } else if (!props.deviceRepairData.form.errors.phone?.trim()) {
        dwhParam = props.deviceRepairData.form.phone.trim();
        (sendingData.startPoint = startPointEnum.PHONE), (sendingData.selectedNumber = props.deviceRepairData.form.phone.trim());
        props.validateAccountToIMEIService(sendingData).then((res) => {
          if (!res.payload?.error){
            if (res.payload?.imeiList?.length > 1) {
              props.setCurrentStep(stepEnum.SELECT_IMEI);
            } else if (res.payload?.openDeliveries?.length >= 1) {
              return null;
            } else {
              props.setCurrentStep(stepEnum.CAUSE_SELECTION);
            }
          }
        });
      }
    } else if (props.deviceRepairData.startPoint === startPointEnum.IMEI) {
      if (!props.deviceRepairData.form.imei?.trim()) {
        handleInputChange({field: 'imei', value: ''});
      } else if (!props.deviceRepairData.form.errors.imei?.trim()) {
        dwhParam = props.deviceRepairData.form.imei.trim();
        (sendingData.startPoint = startPointEnum.IMEI), (sendingData.selectedIMEI = props.deviceRepairData.form.imei.trim());
        props.validateAccountToIMEIService(sendingData).then((res) => {
          if (!res.payload?.error){
            if (res.payload?.imeiList?.length > 1) {
              props.setCurrentStep(stepEnum.SELECT_IMEI);
            } else if (res.payload?.openDeliveries?.length >= 1) {
              return null;
            } else {
              if (props.deviceRepairData.showConfirmPhoneMsg)
              {
                return ;
              }
            }
          }
        });
      }
    } else {
      return null;
    }
    dwhValidateStepButtonClick({selectedHetPay, customerName, subscriber, dwhParam});
  }

  const handleCurrentStep = () => {
    props.confirmPhoneConnectedToIMEI();
    if (props.deviceRepairData.IMEIList?.length > 1) {
      props.setCurrentStep(stepEnum.SELECT_IMEI);
    } else {
      props.setCurrentStep(stepEnum.CAUSE_SELECTION);
    }
  };

  function setSelectedButton(button) {
    if (props.deviceRepairData.showErrorMessage) {
      props.hideErrorMessage();
    }
    props.setStartPoint(button?.toUpperCase());
  }

  const getMessageText = () => {
    switch (props.deviceRepairData.errorType) {
      case errorDescriptionEnum.MEMBER_OF_DIFFERENT_ORG_NOT_ALLOWED_TO_CONTACT_PERSON:
        return `מצטערים!</br> אין לך הרשאה לבצע פעולה עבור חברה המנוי מצומד`;
      case errorDescriptionEnum.ERROR_ON_VALIDATION:
      case errorDescriptionEnum.ORG_ID_NOT_FOUND:
        return `קרתה  תקלה במהלך הזיהוי, אנא נסה שוב מאוחר יותר`;
      case errorDescriptionEnum.ACCOUNT_NOT_FOUND:
        return `המנוי אינו שייך לאחד האירגונים שבאחריותך`;
      case errorDescriptionEnum.NO_EQUIPMENT_IS_ATTACHED:
      case errorDescriptionEnum.WARR_ISSUR_IND:
        return `המכשיר לא כלול באחריות מקיפה&#47;שירות תיקונים.</br>
        יש לפנות לאחראי&#47;ת השירות להמשך טיפול`;
    }
  };

  return (
    <div className="imei-device-repair-client-validation">
      <Title text={'תאום שליחות לתיקון מכשיר'} subtext={'אנא הזינו מספר טלפון או IMEI'} />
      <div className="validate-form">
        <TextFieldWithRadio
          fields={fields}
          onChange={handleInputChange}
          selectedForm={props.deviceRepairData.startPoint.toLowerCase()}
          setSelectedForm={setSelectedButton}
        />
        {props.deviceRepairData.startPoint === startPointEnum.IMEI && props.deviceRepairData.selectedPhoneNumber && (
          <div className="confirm-number-msg"> הIMEI משוייך למנוי {props.deviceRepairData.selectedPhoneNumber}, לאישור
            לחצו "המשך"</div>
        )}
        {props.deviceRepairData.showErrorMessage &&
          <DeniedMessageBox text={getMessageText()} asBtn={false} tel={props.numberCallCenter} />}
      </div>
      <div className="submit-button">
        <BtnSubmit text="המשך" onclick={() => saveToHistoryAndContinue()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, portalState: state.portalsBlock, loginData: state.authentication.loginData};
};

const mapDispatchToProps = {
  setPopup,
  changeHandler,
  setStartPoint,
  validateAccountToIMEIService,
  confirmPhoneConnectedToIMEI,
  setCurrentStep,
  saveToHistory,
  hideErrorMessage,
  saveDWHParams,
  getGeneralData,
  confirmPhoneNumber
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateComponent);
